var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame145(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_2210)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 55.0479,
    width: 12.9524,
    height: 12.9524,
    rx: 1.29524,
    fill: "#F8CC07"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.4573,
    y: 42.0942,
    width: 12.9524,
    height: 25.9048,
    rx: 1.29524,
    fill: "#9628C6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9143,
    y: 29.1426,
    width: 12.9524,
    height: 38.8571,
    rx: 1.29524,
    fill: "#199FDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.0476,
    y: 16.1904,
    width: 12.9524,
    height: 51.8095,
    rx: 1.29524,
    fill: "#E2203D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_2210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame145);
export default __webpack_public_path__ + "static/media/Frame 145.50a8b836ee3a066a50025971e355d6cd.svg";
export { ForwardRef as ReactComponent };